import { jwtDecode } from '../../../node_modules/.pnpm/jwt-decode@4.0.0/node_modules/jwt-decode/build/esm/index.js';
import { localStorageKeys } from '../../config.js';
import { PlatformAPI } from '../../utils/platform.js';
import { LogSentryException, LogSentryMessage } from '../sentryLogger/sentryLogger.js';

const noIFrameSupportBrowserNames = ["Safari", "Mobile Safari"];
const getUserIdFromRefreshToken = () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
        return null;
    }
    try {
        const decodedToken = jwtDecode(refreshToken);
        if (decodedToken && decodedToken.sub) {
            return decodedToken.sub;
        }
    }
    catch (error) {
        LogSentryException({ messagePrefix: "getUserIdFromRefreshToken", error });
        return null;
    }
    return null;
};
const isLoggedIn = () => {
    return getRefreshToken() !== null;
};
const getAccessToken = () => window.localStorage.getItem(localStorageKeys.accessToken);
const getRefreshToken = () => window.localStorage.getItem(localStorageKeys.refreshToken);
const removeTokens = () => {
    window.localStorage.removeItem(localStorageKeys.refreshToken);
    window.localStorage.removeItem(localStorageKeys.accessToken);
};
const setTokens = (refreshToken, accessToken) => {
    window.localStorage.setItem(localStorageKeys.refreshToken, refreshToken);
    window.localStorage.setItem(localStorageKeys.accessToken, accessToken);
};
const CrossWebAppRequest = ({ url, expectedPostMessageEventData, timeout = 5000, }) => {
    const timeoutObject = (() => {
        let timeoutID;
        const promise = new Promise((resolve) => {
            timeoutID = window.setTimeout(() => {
                LogSentryMessage({ message: "CrossWebAppRequest timeout" });
                resolve();
            }, timeout);
        });
        const clear = () => {
            clearTimeout(timeoutID);
        };
        return { promise, clear };
    })();
    const eventPromise = new Promise((resolve) => {
        addEventListener("message", (event) => {
            if (event.origin !== url.origin) {
                return;
            }
            if (event.data === expectedPostMessageEventData) {
                timeoutObject.clear();
                LogSentryMessage({ message: "CrossWebAppRequest finished" });
                resolve();
            }
        });
    });
    let iframe;
    let newWindow = null;
    // For safari we need to open a new tab, because the localstorage changes are not propagated from the iframe
    if (noIFrameSupportBrowserNames.includes(PlatformAPI.getInstance().getBrowserName() ?? "")) {
        newWindow = window.open("about:blank", "_blank");
        if (!newWindow) {
            LogSentryMessage({ message: "CrossWebAppRequest new window blocked" });
            timeoutObject.clear();
            return;
        }
        newWindow.blur();
        window.focus();
        newWindow.location.href = url.href;
    }
    else {
        iframe = document.createElement("iframe");
        iframe.setAttribute("src", url.href);
        iframe.setAttribute("style", "width:0;height:0;border:0;border:none;");
        document.body.appendChild(iframe);
    }
    return Promise.race([eventPromise, timeoutObject.promise]).then(() => {
        if (iframe) {
            document.body.removeChild(iframe);
        }
        if (newWindow) {
            newWindow.close();
        }
    });
};

export { CrossWebAppRequest, getAccessToken, getRefreshToken, getUserIdFromRefreshToken, isLoggedIn, removeTokens, setTokens };
//# sourceMappingURL=authUtils.js.map
